import type { RouteId } from './types';

/**
 * 路由 → 菜单 / 入口上显示的文案 key（CR-040）。
 *
 * 显式映射，理由同 `permission-labels.ts`：拼出来的 key 少一条翻译不会报错，
 * `locales.test.ts` 也看不见。`Record<RouteId, string>` 保证加一条路由就得补一行，
 * `route-labels.test.ts` 再查这些 key 真的在两份语言文件里。
 */
export const ROUTE_LABEL_KEY: Record<RouteId, string> = {
  changePassword: 'auth.changePassword',

  'd.sites': 'nav.sites',
  'd.users': 'nav.users',
  'd.roles': 'nav.roles',
  'd.audit': 'nav.audit',
  'd.orgs': 'nav.orgs',

  'd.overview': 'nav.overview',
  'd.punch': 'nav.punch',
  'd.logs': 'nav.logs',
  'd.drawings': 'nav.drawings',
  'd.schedule': 'nav.schedule',
  'd.hiddenWorks': 'nav.hidden',
  'd.purchases': 'nav.purchases',
  'd.attendance': 'nav.attendance',
  'd.siteSettings': 'nav.siteSettings',

  'm.home': 'nav.home',
  'm.overview': 'nav.overview',
  'm.punch': 'nav.punch',
  'm.logs': 'nav.logs',
  'm.drawings': 'nav.drawings',
  'm.schedule': 'nav.schedule',
  'm.hidden': 'nav.hidden',
  'm.purchases': 'nav.purchases',
  'm.review': 'nav.review',
  'm.attendance': 'nav.attendance',
  'm.me': 'nav.me',
  'm.system': 'settings.system',
  'm.siteSettings': 'nav.siteSettings',
  'm.sites': 'nav.sites',
  'm.users': 'nav.users',
  'm.roles': 'nav.roles',
  'm.audit': 'nav.audit',
  'm.orgs': 'nav.orgs',
};
